import { useTranslation } from "react-i18next"
import { useStore } from '../../contexts/store'
import { observer } from 'mobx-react-lite'
import { Box, Button } from '@mui/material'
import Infobox from "../Infobox"
import { navigate } from "wouter/use-browser-location"

const PdfError = () => {
  const { t } = useTranslation()
  const { podStore, uiStore } = useStore()

  return <Box sx={{height: "80dvh", alignContent: "center"}}>
  <Infobox sx={{margin: "20px"}}>
    {t("Could not load File")}
    <Box sx={{fontSize: "12px", color: "grey"}}>{uiStore.pdfError}</Box>
    <Box sx={{display: "flex", flexWrap: "wrap", justifyContent: "end", marginTop: "15px", gridGap: "8px"}}>
     <Button variant="outlined" onClick={() => {
        navigate(`/pod/${podStore.pod?.podId || ''}/contents`, {state: {prevUrl: window.location.pathname}})
        uiStore.setPdfError(null)
        }}>{t('Back to Pod Contents')}</Button>
     <Button variant="contained" onClick={() => { uiStore.setPdfError(null) }}>{t('Retry')}</Button>
   </Box>
  </Infobox>
</Box>
}

export default observer(PdfError)